import styled from 'styled-components'

import type { Theme } from './types'

const isDarkMode = (theme: Theme) => theme.title === 'dark'

export const ModalHeaderContainer = styled.div`
  display: flex;
  text-align: center;
  width: 100%;
`

export const ModalHeaderTitle = styled.h2`
  font-size: var(--text-3);
  padding: 0;
  margin: 0;
  margin-top: var(--spacer-5);
  font-weight: var(--font-weight-bold);
  text-align: center;
  color: ${({ theme }) => (isDarkMode(theme) ? 'var(--white)' : 'var(--black)')};
  width: 90%;
`

export const ModalHeaderCloseButton = styled.button`
  border: none;
  background: transparent;
  color: ${({ theme }) => (isDarkMode(theme) ? 'var(--gray-700)' : 'var(--black)')};
  padding: 0;
  width: 10%;

  &:hover {
    cursor: pointer;
  }
`

export const ModalBodyContent = styled.div`
  display: flex;
  flex-flow: column;
  padding: var(--spacer-2);
`

export const ModalBodyContentSteps = styled.div`
  display: flex;
  flex-flow: column;
  margin-bottom: var(--spacer-6);
  align-items: center;

  &:last-child {
    margin-bottom: var(--spacer-4);
  }

  h4 {
    color: ${({ theme }) => (isDarkMode(theme) ? 'var(--white)' : 'var(--black)')};
    font-size: var(--text-2);
    font-weight: var(--font-weight);
    padding-bottom: var(--spacer-3);
    margin: 0;
  }
`

export const ModalBodyContentStepIconRounded = styled.div`
  display: flex;
  justify-content: center;
  color: var(--white);

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
    background-color: var(--gray-600);
    padding: var(--spacer-5);
    width: 0;
    height: 0;
    box-sizing: border-box;
  }
`

export const ModalBodyContentStepIconRectangle = styled.div`
  color: var(--white);
  font-size: var(--text-1);
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  max-width: 220px;
  background-color: var(--gray-600);
  padding: var(--spacer-3);
  justify-content: space-between;
  border-radius: var(--border-radius);
`

export const ModalBodyContentStepIconWithImage = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;

  > img {
    width: 100%;
    max-width: 300px;
    height: auto;
  }

  > div {
    display: flex;
    justify-content: space-between;
    color: var(--white);
    font-size: var(--text-1);
    width: 100%;
    max-width: 300px;
    background-color: var(--gray-600);
    padding: var(--spacer-3);
    border-radius: var(--border-radius);

    .blue {
      color: ${({ theme }) => (isDarkMode(theme) ? 'var(--blue-dark)' : 'var(--blue)')};
    }
  }
`
